import { render } from "./RoundedToggle.vue?vue&type=template&id=484482bc&scoped=true"
import script from "./RoundedToggle.vue?vue&type=script&lang=js"
export * from "./RoundedToggle.vue?vue&type=script&lang=js"

import "./RoundedToggle.vue?vue&type=style&index=0&id=484482bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-484482bc"

export default script